import { type ICompanyRegistrationProfileInfoQuery } from 'application/querySchemas/ICompanyRegistrationProfileInfoQuery';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import {
    type ICompanyRegistrationProfileInfoClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/ICompanyRegistrationProfileInfoClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class CompanyRegistrationProfileInfoQuery implements ICompanyRegistrationProfileInfoQuery {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanyRegistrationProfileInfoClient')
        public readonly companyRegistrationProfileInfoClient: ICompanyRegistrationProfileInfoClient,
    ) {}

    public async fetch(): Promise<IGetResponse['data']> {
        const { data, message } = await this.companyRegistrationProfileInfoClient.get({});
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
